import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	type SelectChangeEvent,
} from "@mui/material";
import { usePassTypesLookup } from "../hooks/usePassIds";

interface PassTypeSelectorProps {
	value: number | null;
	onChange: (value: number | null) => void;
	label?: string;
	fullWidth?: boolean;
	required?: boolean;
	size?: "small" | "medium";
	disabled?: boolean;
	includeAll?: boolean;
}

export const PassTypeSelector = ({
	value,
	onChange,
	label = "Pass Type",
	fullWidth = false,
	required = false,
	size = "small",
	disabled = false,
	includeAll = false,
}: PassTypeSelectorProps) => {
	const { data: passTypes = [], isLoading } = usePassTypesLookup();

	const handleChange = (event: SelectChangeEvent<number | "">) => {
		const val = event.target.value;
		onChange(val === "" ? null : (val as number));
	};

	return (
		<FormControl
			fullWidth={fullWidth}
			size={size}
			required={required}
			sx={{ minWidth: 150 }}
		>
			<InputLabel>{label}</InputLabel>
			<Select
				value={value ?? ""}
				onChange={handleChange}
				label={label}
				disabled={disabled || isLoading}
			>
				{includeAll && (
					<MenuItem value="">
						<em>All</em>
					</MenuItem>
				)}
				{passTypes.map((pt) => (
					<MenuItem key={pt.Id} value={pt.Id}>
						{pt.Name}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
